import type { HTMLAttributes } from 'react';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const sizeClass: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

interface LoadingSpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: SpinnerSize;
}

/** Spinner circular reutilizable (teal / brand). */
export function LoadingSpinner({ size = 'md', className = '', ...rest }: LoadingSpinnerProps) {
  return (
    <span
      aria-hidden
      className={`inline-block shrink-0 animate-spin rounded-full border-teal-200 border-t-teal-600 dark:border-teal-900 dark:border-t-teal-400 ${sizeClass[size]} ${className}`}
      {...rest}
    />
  );
}
